import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  createTransform,
  REGISTER,
} from "redux-persist";
import reducers from "./reducers";
import createIdbStorage from 'redux-persist-indexeddb-storage';
import CryptoJS from 'crypto-js';

const SECRET_KEY = 'your-strong-secret-key';

// 🔐 Encryption functions
const encrypt = (data) =>
  CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();

const decrypt = (data) => {
  const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
};

// 🧠 Transform to encrypt/decrypt specific slices
const encryptTransform = createTransform(
  (inboundState) => encrypt(inboundState),
  (outboundState) => decrypt(outboundState)
);

const idbStorage = createIdbStorage({ name: 'secureAppStore' });

const persistConfig = {
  key: "root",
  storage: idbStorage,
  transforms: [encryptTransform],
  blacklist: ['largeData'],
};
const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
const persistor = persistStore(store);

export { persistor };
export default store;
